import React from 'react'
import styled from 'styled-components'
import { TextArea, Typography } from 'sputnik-ui'
import { useTranslation } from 'react-i18next'

export const CAMERA_NOTICE_MAX_LENGTH = 200

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 7px;
`

const FieldWrapper = styled.div`
  position: relative;
`

const Counter = styled(Typography)`
  && {
    position: absolute;
    right: 12px;
    bottom: 10px;
    color: ${(p) => p.theme.palette.text.secondary};
    font-size: 11px;
    line-height: 16px;
    pointer-events: none;
  }
`

const Helper = styled(Typography)`
  && {
    display: block;
    margin-top: 6px;
  }
`

export const CameraNoticeField = ({
  value = '',
  onChange,
  error,
  disabled,
  optional = false,
  ...props
}) => {
  const { t } = useTranslation('devices')

  return (
    <div {...props}>
      <Header>
        <Typography variant="note" color="textSecondary">
          {t('devices:camera_notice.label')}
        </Typography>
        {optional && (
          <Typography variant="note" color="textSecondary">
            {t('devices:camera_notice.optional')}
          </Typography>
        )}
      </Header>
      <FieldWrapper>
        <TextArea
          value={value}
          onChange={onChange}
          error={Boolean(error)}
          disabled={disabled}
          rows="2"
          maxLength={CAMERA_NOTICE_MAX_LENGTH}
          inputProps={{
            // не даём тексту заезжать под абсолютно позиционированный счётчик
            style: { resize: 'none', paddingRight: 74, paddingBottom: 26 },
          }}
        />
        <Counter variant="note">
          {value.length} / {CAMERA_NOTICE_MAX_LENGTH}
        </Counter>
      </FieldWrapper>
      <Helper variant="note" color={error ? 'error' : 'textSecondary'}>
        {error || t('devices:camera_notice.helper')}
      </Helper>
    </div>
  )
}
